// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__Sv-D3","content":"LayoutSettings_content__qCaS-"};